/** Sidebar drawer width in px (used by layout and AppBar offset). */
export const DRAWER_WIDTH = 280;

/** Sidebar background by theme mode. */
export const SIDEBAR_BACKGROUND: Record<"light" | "dark", string> = {
  light: "#1a0533",
  dark: "#0d0618",
};
